import React from "react";
import { Button } from "semantic-ui-react";

import Calibration1_MAIN from "./Calibration1_MAIN";
import Calibration2_MAIN from "./Calibration2_MAIN";
import Calibration3_MAIN from "./Calibration3_MAIN";
import Calibration4_MAIN from "./Calibration4_MAIN";

import NonLinear_MAIN from "./NonLinear_MAIN";

const CalibrationIO_MAIN = () => {
  const [toggleButton, setToggleButton] = React.useState("1");

  const handleClick = (e, { id }) => {
    setToggleButton(id);
  };

  const renderSwitch = (param) => {
    switch (param) {
      case "1":
        return <Calibration1_MAIN />;
      case "2":
        return <Calibration2_MAIN />;
      // case '3':
      //     return <Calibration3_MAIN/>;
      //  case '4':
      //     return <Calibration4_MAIN/>;
      case "5":
        return <NonLinear_MAIN />;
      default:
        return <Calibration1_MAIN />;
    }
  };

  return (
    <div style={styles.div}>
      <Button.Group toggle style={styles.toggle}>
        <Button
          size="medium"
          id="1"
          active={toggleButton === "1"}
          onClick={handleClick}
          content="Analog IO Calibration Page1"
        />
        <Button
          size="medium"
          id="2"
          active={toggleButton === "2"}
          onClick={handleClick}
          content="Analog IO Calibration Page2"
        />
        {/*<Button*/}
        {/*    size='medium'*/}
        {/*    id='3'*/}
        {/*    active={toggleButton==='3'}*/}
        {/*    onClick={handleClick}*/}
        {/*    content='Analog IO Calibration Page3'*/}
        {/*/>*/}
        {/* <Button*/}
        {/*    size='medium'*/}
        {/*    id='4'*/}
        {/*    active={toggleButton==='4'}*/}
        {/*    onClick={handleClick}*/}
        {/*    content='Analog IO Calibration Page4'*/}
        {/*/>*/}
        <Button
          size="medium"
          id="5"
          active={toggleButton === "5"}
          onClick={handleClick}
          content="Non Linear Calibration"
        />
      </Button.Group>
      {renderSwitch(toggleButton)}
    </div>
  );
};

const styles = {
  div: {
    textAlign: "center",
  },
  toggle: {
    marginLeft: "8px",
  },
};

export default CalibrationIO_MAIN;
